/**
 * QR Code configuration
 */

export const QR_CONFIG = {
  // Default QR code size in pixels
  DEFAULT_SIZE: 300,

  // Error correction level (L: 7%, M: 15%, Q: 25%, H: 30%)
  ERROR_CORRECTION_LEVEL: 'H',

  // Icon overlay settings
  ICON: {
    // Default icon path
    DEFAULT_PATH: '/app_icon_512.png',
    // Size ratio relative to QR code size (15%)
    SIZE_RATIO: 0.15,
    // Corner radius ratio relative to icon size (20%)
    CORNER_RADIUS_RATIO: 0.2,
  },
};
